/* Offres quantité (Vanille Désiré)
   Les cartes radio pilotent l'input quantité du bloc quantity_selector
   (#Quantity-<sectionId>, attribut form= du formulaire produit).
   La remise réelle est portée par une remise automatique native côté admin :
   ici, uniquement de l'affichage + le pilotage de la quantité. */

if (!customElements.get('vd-quantity-offers')) {
  customElements.define(
    'vd-quantity-offers',
    class VdQuantityOffers extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.initPrices();
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        // Pile live (sections/vd-yc-product.liquid) : le stepper n'a pas d'id
        // Dawn, l'input quantité vit DANS le formulaire [data-vd-pdp-form].
        // On garde l'ancrage Dawn en premier pour rester compatible.
        this.quantityInput =
          document.getElementById(`Quantity-${this.sectionId}`) ||
          document.querySelector('[data-vd-pdp-form] input[name="quantity"]') ||
          document.querySelector('[data-vd-pdp] .vd-pdp__qty-input');
        if (!this.quantityInput || this.radios.length === 0) return;

        this.syncing = false;

        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => {
            if (this.syncing || !radio.checked) return;
            this.setQuantity(parseInt(radio.value, 10));
          });
        });

        // Si le client modifie la quantité à la main, on resynchronise les cartes.
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.quantityInput.addEventListener('change', this.onQuantityChange);
        this.onQuantityChange();
      }

      disconnectedCallback() {
        if (this.variantSelect && this.onVariantChange) {
          this.variantSelect.removeEventListener('change', this.onVariantChange);
        }
        if (this.quantityInput) {
          this.quantityInput.removeEventListener('change', this.onQuantityChange);
        }
      }

      /* ---- Recalcul des montants quand la variante change ----
         Le bloc affichait les prix de la premiere variante meme apres un
         changement : un client qui choisissait « 5 gousses » lisait encore le
         prix de « 1 gousse ». On embarque donc tous les prix (data-prices) et
         on recalcule a chaque changement du <select data-vd-variant-select>. */
      initPrices() {
        try { this.prices = JSON.parse(this.dataset.prices || '{}'); }
        catch (e) { this.prices = {}; }
        this.moneyFormat = this.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
        this.tier2 = parseInt(this.dataset.tier2Percent || '10', 10);
        this.tier3 = parseInt(this.dataset.tier3Percent || '15', 10);
        if (!Object.keys(this.prices).length) return;

        const form = this.closest('form') || document.querySelector('[data-vd-pdp-form]');
        this.variantSelect =
          (form && form.querySelector('[data-vd-variant-select]')) ||
          document.querySelector('[data-vd-variant-select]');
        if (!this.variantSelect) return;

        this.onVariantChange = this.onVariantChange.bind(this);
        this.variantSelect.addEventListener('change', this.onVariantChange);
        this.onVariantChange();
      }

      formatMoney(cents) {
        const v = Math.round(cents) / 100;
        const withComma = v.toFixed(2).replace('.', ',');
        const withDot = v.toFixed(2);
        const noDec = String(Math.round(v));
        return this.moneyFormat
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
          .replace(/\{\{\s*amount\s*\}\}/g, withDot);
      }

      onVariantChange() {
        const id = this.variantSelect && this.variantSelect.value;
        const unit = this.prices[id];
        if (!Number.isFinite(unit)) return;

        const set = (sel, cents) => {
          const el = this.querySelector(sel);
          if (el) el.textContent = this.formatMoney(cents);
        };
        set('[data-qo-total="1"]', unit);
        [[2, this.tier2], [3, this.tier3]].forEach(([qty, pct]) => {
          const full = unit * qty;
          // Liquid fait une division entiere (`divided_by: 100` tronque) et c'est
          // ce montant que le panier facture reellement : on tronque pareil,
          // sinon l'affichage decale d'un centime par rapport au paiement.
          const save = Math.floor((full * pct) / 100);
          set('[data-qo-compare="' + qty + '"]', full);
          set('[data-qo-total="' + qty + '"]', full - save);
          set('[data-qo-save="' + qty + '"]', save);
        });
      }

      setQuantity(quantity) {
        if (!Number.isFinite(quantity) || quantity < 1) return;
        this.syncing = true;
        this.quantityInput.value = quantity;
        // Event 'change' bubbles : quantity-input (Dawn) met à jour ses boutons +/-.
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.syncing = false;
      }

      onQuantityChange() {
        if (this.syncing) return;
        const value = String(parseInt(this.quantityInput.value, 10) || 1);
        this.syncing = true;
        this.radios.forEach((radio) => {
          radio.checked = radio.value === value;
        });
        this.syncing = false;
      }
    }
  );
}
